<template>
  <b-form-row>
    <b-modal
      size="xl"
      button-size="sm"
      ref="finder"
      hide-footer
      :id="this.id"
      :title="title"
    >
      <TipoEmpenhoList :prefix="updatedPrefix" @onDblClickTipoEmpenhoSelect="tipoEmpenhoSelect" />
    </b-modal>

    <lg-form-input-finder
      :value="computedValue"
      @input="updateValue"
      fieldDescription="descricao"
      label="Tipo de Empenho: *"
      invalidFeedback="Tipo de Empenho deve ser informado!"
      description=""
      @handleClean="handleClean"
      :error="error"
    >
      <template #prepend>
        <b-button
          @click="show"
          class="btn-input-finder"
          pressed
        >
          <b-icon icon="search" />
        </b-button>
      </template>
    </lg-form-input-finder>
  </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";
import TipoEmpenhoList from "@/modules/cadastros/tipo-empenho/TipoEmpenhoList.vue";

export default {
  components: { LgFormInputFinder, TipoEmpenhoList },
  props: {
    id: String,
    prefix: Array,
    value: Object,
    error: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      internalValue: this.value || {},
    };
  },
  watch: {
    value(newValue) {
      this.internalValue = newValue;
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.internalValue;
      },
      set(newValue) {
        this.internalValue = newValue;
      },
    },
    updatedPrefix() {
      return [...this.prefix, "Tipo de Empenho"];
    },
    title() {
      return this.updatedPrefix.join(" > ");
    },
  },
  methods: {
    show() {
      this.$bvModal.show(this.id);
    },
    updateValue(newValue) {
      this.computedValue = newValue;
      this.$emit('input', newValue);
    },
    handleClean() {
      this.computedValue = {};
      this.$emit('input', {});
    },
    tipoEmpenhoSelect(item) {
      this.computedValue = item;
      this.$emit('input', item);
      this.$bvModal.hide(this.id);
    },
  },
};
</script>
